import { useSolvedFields } from 'components/common-form/hooks/useSolvedFieldsLabels';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

export const SolvedFieldsRatioLabel: FC<{ className?: string; e2e: string }> = ({ className, e2e }) => {
  const { formatMessage, formatNumber } = useIntl();

  const solvedFields = useSolvedFields();

  const isRatio = useMemo<boolean>(
    () => solvedFields.length === 2 && Number.isFinite(solvedFields[0].value) && !!solvedFields[1].value,
    [solvedFields],
  );

  const fields = useMemo<string>(() => solvedFields.map(field => field.label).join(' / '), [solvedFields]);

  const ratioValue = useMemo<string>(
    () => (isRatio ? formatNumber(solvedFields[0].value / solvedFields[1].value, { maximumFractionDigits: 4 }) : '?'),
    [isRatio, formatNumber, solvedFields],
  );

  return !isRatio ? null : (
    <div className={className} data-e2e={e2e}>
      {formatMessage(
        { id: 'form.SolvingMode.ratio.label' },
        {
          fields,
          ratioValue,
        },
      )}
    </div>
  );
};
